export default "../css/071244c042700e6211ac5022cd5da8f2.ttf";